// Outbound links + the one dynamic call the marketing site makes (the sales
// contact form POSTs to the API). Prod defaults are baked in; override per
// environment with VITE_* vars (see .env.example).

const env = import.meta.env;

export const APP_URL: string = env.VITE_APP_URL ?? 'https://dashboard.caratuva.com';

// The self-service B2C app (getpaid.caratuva.com): sellers sign up, onboard,
// and create invoices with shareable payment links. This is the primary CTA
// destination on the marketing site; the dashboard (APP_URL) stays the entry
// point for platforms/integrators.
export const GETPAID_URL: string = env.VITE_GETPAID_URL ?? 'https://getpaid.caratuva.com';

export const DOCS_URL: string = env.VITE_DOCS_URL ?? 'https://docs.caratuva.com';
export const CONTACT_EMAIL: string = env.VITE_CONTACT_EMAIL ?? 'sales@caratuva.com';

// API host for the public sales-contact form. Defaults to the production API;
// set VITE_API_URL=http://localhost:3000 for local dev. The API must allowlist
// this site's origin via PUBLIC_WEB_ORIGINS (CORS) in non-dev environments.
export const API_URL: string = env.VITE_API_URL ?? 'https://api.caratuva.com';
export const CONTACT_ENDPOINT = `${API_URL.replace(/\/$/, '')}/v1/public/contact`;

// WhatsApp click-to-chat — digits only (country + area + number), no '+'.
// Defaults to the Caratuva sales line; override with VITE_WHATSAPP_NUMBER.
export const WHATSAPP_NUMBER: string = env.VITE_WHATSAPP_NUMBER ?? '5541988751382';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

// Self-service signup is the same passwordless magic-link entry point as
// sign-in: the dashboard materializes the account on first magic-link consume.
export const SIGNUP_URL = `${APP_URL}/login`;
export const SIGNIN_URL = `${APP_URL}/login`;

// Self-service signup/sign-in for the B2C getpaid app. Affiliate referral links
// append ?ref=CODE to this login entry point.
export const GETPAID_SIGNUP_URL = `${GETPAID_URL}/login`;

// API reference lives inside the docs site.
export const API_DOCS_URL = `${DOCS_URL}/api-reference`;

export const CONTACT_URL = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  'Caratuva — production access',
)}`;
